/* eslint-disable */
// ============================================================
//  GEO - Pays, régions, coordonnées, Leaflet map template
//  (extrait de constants.js le 27 mai 2026 pour réduire sa taille)
// ============================================================

export const COUNTRIES = [
  // === EUROPE ===
  { code: "CH", name: "Suisse", flag: "🇨🇭", regions: [
    "Vaud","Genève","Fribourg","Valais","Neuchâtel","Jura","Berne","Tessin",
    "Zurich","Lucerne","Argovie","Soleure","Bâle-Ville","Bâle-Campagne",
    "Saint-Gall","Grisons","Schwyz","Thurgovie","Schaffhouse","Appenzell",
    "Uri","Glaris","Obwald","Nidwald","Zoug"
  ]},
  { code: "FR", name: "France", flag: "🇫🇷", regions: [
    "Île-de-France","Auvergne-Rhône-Alpes","Provence-Alpes-Côte d'Azur",
    "Normandie","Occitanie","Nouvelle-Aquitaine","Hauts-de-France","Grand Est",
    "Bretagne","Pays de la Loire","Bourgogne-Franche-Comté","Centre-Val de Loire",
    "Corse","DOM-TOM"
  ]},
  { code: "BE", name: "Belgique", flag: "🇧🇪", regions: [
    "Wallonie","Flandre","Bruxelles"
  ]},
  { code: "NL", name: "Pays-Bas", flag: "🇳🇱", regions: [
    "Hollande-Septentrionale","Hollande-Méridionale","Utrecht","Brabant-Septentrional",
    "Gueldre","Limbourg","Overijssel","Frise","Groningue","Drenthe","Flevoland","Zélande"
  ]},
  { code: "DE", name: "Allemagne", flag: "🇩🇪", regions: [
    "Bavière","Bade-Wurtemberg","Hesse","Rhénanie-du-Nord-Westphalie",
    "Basse-Saxe","Saxe","Berlin","Hambourg","Brandebourg","Schleswig-Holstein",
    "Thuringe","Rhénanie-Palatinat","Saxe-Anhalt","Mecklembourg",
    "Sarre","Brême"
  ]},
  { code: "GB", name: "Royaume-Uni", flag: "🇬🇧", regions: [
    "Angleterre","Écosse","Pays de Galles","Irlande du Nord"
  ]},
  { code: "IE", name: "Irlande", flag: "🇮🇪", regions: [
    "Leinster","Munster","Connacht","Ulster","Dublin"
  ]},
  { code: "IT", name: "Italie", flag: "🇮🇹", regions: [
    "Lombardie","Toscane","Vénétie","Piémont","Émilie-Romagne","Latium",
    "Sicile","Campanie","Pouilles","Sardaigne","Ligurie","Marches","Ombrie",
    "Frioul","Trentin-Haut-Adige","Calabre","Abruzzes","Basilicate","Molise",
    "Vallée d'Aoste"
  ]},
  { code: "ES", name: "Espagne", flag: "🇪🇸", regions: [
    "Catalogne","Andalousie","Madrid","Valence","Galice","Castille-et-León",
    "Pays basque","Castille-La Manche","Canaries","Murcie","Aragon","Estrémadure",
    "Asturies","Navarre","Cantabrie","La Rioja","Baléares","Ceuta","Melilla"
  ]},
  { code: "PT", name: "Portugal", flag: "🇵🇹", regions: [
    "Lisbonne","Porto","Algarve","Alentejo","Centre","Nord","Açores","Madère"
  ]},
  { code: "AT", name: "Autriche", flag: "🇦🇹", regions: [
    "Vienne","Basse-Autriche","Haute-Autriche","Styrie","Tyrol","Carinthie",
    "Salzbourg","Vorarlberg","Burgenland"
  ]},
  { code: "SE", name: "Suède", flag: "🇸🇪", regions: [
    "Stockholm","Göteborg","Malmö","Uppsala","Skåne","Västra Götaland","Autres"
  ]},
  { code: "NO", name: "Norvège", flag: "🇳🇴", regions: [
    "Oslo","Bergen","Trondheim","Stavanger","Autres"
  ]},
  { code: "DK", name: "Danemark", flag: "🇩🇰", regions: [
    "Copenhague","Aarhus","Odense","Aalborg","Autres"
  ]},
  { code: "PL", name: "Pologne", flag: "🇵🇱", regions: [
    "Mazovie","Petite-Pologne","Silésie","Grande-Pologne","Basse-Silésie","Autres"
  ]},
  { code: "LU", name: "Luxembourg", flag: "🇱🇺", regions: ["Luxembourg"] },
  { code: "MC", name: "Monaco", flag: "🇲🇨", regions: ["Monaco"] },
  
  // === AMÉRIQUE ===
  { code: "US", name: "États-Unis", flag: "🇺🇸", regions: [
    "Californie","Texas","Floride","Kentucky","Virginie","New York","Colorado",
    "Wyoming","Montana","Oklahoma","Arizona","Pennsylvanie","Massachusetts",
    "Caroline du Nord","Géorgie","Autres états"
  ]},
  { code: "CA", name: "Canada", flag: "🇨🇦", regions: [
    "Ontario","Québec","Alberta","Colombie-Britannique","Manitoba","Saskatchewan",
    "Nouvelle-Écosse","Nouveau-Brunswick","Autres provinces"
  ]},
  { code: "AR", name: "Argentine", flag: "🇦🇷", regions: [
    "Buenos Aires","Córdoba","Mendoza","Santa Fe","Patagonie","Autres"
  ]},
  { code: "BR", name: "Brésil", flag: "🇧🇷", regions: [
    "São Paulo","Rio de Janeiro","Minas Gerais","Bahia","Rio Grande do Sul",
    "Paraná","Autres états"
  ]},
  { code: "MX", name: "Mexique", flag: "🇲🇽", regions: [
    "Mexico","Jalisco","Nuevo León","Yucatán","Autres états"
  ]},
  
  // === MOYEN-ORIENT & AFRIQUE ===
  { code: "AE", name: "Émirats arabes unis", flag: "🇦🇪", regions: [
    "Dubaï","Abu Dhabi","Sharjah","Autres émirats"
  ]},
  
  // === OCÉANIE ===
  { code: "AU", name: "Australie", flag: "🇦🇺", regions: [
    "Nouvelle-Galles du Sud","Victoria","Queensland","Australie-Occidentale",
    "Australie-Méridionale","Tasmanie","Territoire du Nord","Capitale"
  ]},
  { code: "NZ", name: "Nouvelle-Zélande", flag: "🇳🇿", regions: [
    "Auckland","Wellington","Canterbury","Otago","Autres régions"
  ]},
  
  // === AUTRE ===
  { code: "OTHER", name: "Autre pays", flag: "🌍", regions: ["Autre"] }
];

export const ALL_REGIONS = COUNTRIES.flatMap(c => c.regions.map(r => ({region: r, country: c.code, flag: c.flag})));

export const MAP_HTML = `<!DOCTYPE html><html><head><meta charset='utf-8'/><meta name='viewport' content='width=device-width,initial-scale=1'/><link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css'/><link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/MarkerCluster.min.css'/><link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/MarkerCluster.Default.min.css'/><script src='https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js'><\/script><script src='https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.min.js'><\/script><style>*{margin:0;padding:0;box-sizing:border-box;}html,body,#map{width:100%;height:100%;background:#f1ede4;}.mk{width:38px;height:38px;border-radius:50%;border:2.5px solid #fff;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(0,0,0,.25), 0 0 0 1px rgba(0,0,0,.05);cursor:pointer;transition:transform .2s, box-shadow .2s;position:relative;}.mk::after{content:'';position:absolute;inset:-3px;border-radius:50%;background:inherit;opacity:.3;filter:blur(6px);z-index:-1;}.mk:hover{transform:scale(1.18);box-shadow:0 6px 22px rgba(0,0,0,.35), 0 0 0 1px rgba(0,0,0,.12);}.mk-pulse{position:absolute;inset:-4px;border-radius:50%;border:2px solid currentColor;opacity:0;animation:mk-ping 2.2s ease-out infinite;}.mk-sobre::after{display:none;}@keyframes mk-ping{0%{transform:scale(.85);opacity:.7;}80%{transform:scale(1.8);opacity:0;}100%{transform:scale(1.8);opacity:0;}}.mk-emoji{font-size:19px;filter:drop-shadow(0 1px 2px rgba(0,0,0,.25));}.leaflet-popup-content-wrapper{border-radius:14px;box-shadow:0 12px 36px rgba(0,0,0,.18), 0 0 0 1px rgba(0,0,0,.06);padding:0;overflow:hidden;border:none;background:#fff;}.leaflet-popup-content{margin:0;padding:0;min-width:210px;color:var(--text,#1A1A2E);}.popup-card{cursor:pointer;}.popup-photo{width:100%;height:108px;background:linear-gradient(135deg,#f6f3ec,#e6dfd0);background-size:cover;background-position:center;}.popup-info{padding:10px 12px 12px;}.popup-title{font-family:'Barlow Condensed',sans-serif;font-size:14px;font-weight:800;color:#1A1A2E;margin-bottom:4px;line-height:1.25;}.popup-loc{font-size:11px;color:#666;margin-bottom:6px;}.popup-price{font-size:14px;font-weight:800;color:#C8001A;font-family:'Barlow Condensed',sans-serif;}.leaflet-popup-tip{background:#fff!important;box-shadow:none!important;}.leaflet-popup-close-button{color:rgba(0,0,0,.4)!important;font-size:18px!important;padding:6px 8px 0 0!important;}.leaflet-control-zoom{border:none!important;box-shadow:0 4px 14px rgba(0,0,0,.18)!important;}.leaflet-control-zoom a{border-radius:10px!important;border:1px solid rgba(0,0,0,.06)!important;width:32px!important;height:32px!important;line-height:30px!important;font-size:18px!important;font-weight:600!important;background:rgba(255,255,255,.95)!important;color:#1A1A2E!important;margin-bottom:4px!important;backdrop-filter:blur(10px);}.leaflet-control-zoom a:hover{background:#C8001A!important;color:#fff!important;}.leaflet-control-attribution{font-size:9px!important;background:rgba(255,255,255,.9)!important;color:#666!important;padding:2px 6px!important;border-radius:6px!important;}.leaflet-control-attribution a{color:#C8001A!important;}#empty{display:none;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;color:#666;font-family:sans-serif;font-size:13px;}.hc-locate{width:36px;height:36px;line-height:36px;text-align:center;font-size:18px;background:rgba(255,255,255,.95);border:1px solid rgba(0,0,0,.06);border-radius:10px;box-shadow:0 4px 14px rgba(0,0,0,.18);cursor:pointer;backdrop-filter:blur(10px);user-select:none;}.hc-locate:hover{background:#C8001A;}<\/style><\/head><body><div id='map'><\/div><div id='empty'>Aucune annonce sur la carte<\/div><script>
var esc=function(s){return String(s==null?'':s).replace(/[&<>\"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',\"'\":'&#39;'}[c];});};
var safeUrl=function(u){u=String(u||'');return /^https?:\\/\\//i.test(u)?u.replace(/[()'\"\\s]/g,encodeURIComponent):'';};
var map = L.map('map', { zoomControl: true, attributionControl: true, preferCanvas: true }).setView([46.8, 8.2], 7);
// Tuiles OpenStreetMap standard — TRÈS détaillées (rues, sentiers, POIs,
// noms de villages, bâtiments…). Gratuit sans clé, parfait pour l'équestre
// (sentiers, écuries, manèges souvent référencés sur OSM).
// Fallback CARTO Voyager (plus stylé) si OSM indisponible.
var mainTiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  subdomains: 'abc',
  maxZoom: 19,
  attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
});
mainTiles.on('tileerror', function() {
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', { subdomains: 'abcd', maxZoom: 19, attribution: '© CARTO' }).addTo(map);
});
mainTiles.addTo(map);

// Bouton "Me localiser" — présent sur TOUTES les cartes (elles partagent MAP_HTML).
var HcLocate = L.Control.extend({
  options: { position: 'topright' },
  onAdd: function() {
    var b = L.DomUtil.create('div', 'hc-locate');
    b.innerHTML = '📍'; b.title = 'Me localiser';
    L.DomEvent.disableClickPropagation(b);
    L.DomEvent.on(b, 'click', function() {
      if (!navigator.geolocation) { b.innerHTML = '❌'; setTimeout(function(){ b.innerHTML='📍'; }, 1500); return; }
      b.innerHTML = '⏳';
      navigator.geolocation.getCurrentPosition(
        function(pos) { b.innerHTML = '📍'; try { window.goToLocation(pos.coords.latitude, pos.coords.longitude, 13); } catch(e){} },
        function() { b.innerHTML = '❌'; setTimeout(function(){ b.innerHTML='📍'; }, 1800); },
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 30000 }
      );
    });
    return b;
  }
});
map.addControl(new HcLocate());
var markers = [];
var circles = [];
var polylines = [];
var catColors = { horses:'#C8001A', stables:'#1A1A2E', lessons:'#0369A1', events:'#C4690A', stages:'#7C3AED', care:'#047857', photo:'#0C4A6E', jobs:'#A35207', estate:'#0891B2', tarifs:'#0D6E6E', pension:'#5A9020', transport:'#B42020', rental:'#0F766E', search:'#7C2D12', kids:'#BE185D', ecurie:'#065F46', other:'#1A1A2E' };
var catEmojis = { horses:'🐴', stables:'🏠', lessons:'🎓', events:'🏆', stages:'📚', care:'⚕️', photo:'📷', jobs:'💼', estate:'🏡', tarifs:'💰', pension:'🐎', transport:'🚛', rental:'🛍️', search:'🔍', kids:'🧒', ecurie:'🏇', other:'⭐' };

function clearCircles() {
  circles.forEach(function(c){ try { map.removeLayer(c); } catch(e){} });
  circles = [];
}
function clearPolylines() {
  polylines.forEach(function(p){ try { map.removeLayer(p); } catch(e){} });
  polylines = [];
}
// Regroupement des marqueurs. Chaque marqueur decore (.mk) coute une animation
// infinie (.mk-pulse) ET un filtre blur (.mk::after) : a 548 fiches d'annuaire
// le navigateur repeignait 548 elements a chaque image et la carte devenait
// injouable. preferCanvas ne sauvait rien -- il n'agit QUE sur les couches
// vectorielles, jamais sur un divIcon, qui reste du DOM.
// Le cluster ne garde dans le DOM que ce qui est reellement visible.
var markerGroup = null;
var SEUIL_REGROUPEMENT = 60;
function clusterDispo() { return typeof L.markerClusterGroup === 'function'; }

// Renvoie un groupe de regroupement, ou null s'il n'y a pas assez de points
// (on garde alors les marqueurs decores) ou si le CDN n'a pas repondu.
function creerGroupe(n) {
  if (n <= SEUIL_REGROUPEMENT || !clusterDispo()) return null;
  return L.markerClusterGroup({
    chunkedLoading: true,
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    maxClusterRadius: 55
  });
}

// Fabrique UNIQUE de marqueur decore, utilisee par toutes les couches.
// En mode sobre on retire le halo anime et le filtre blur : ce sont les deux
// seuls effets qui coutent a CHAQUE image, et ils se multiplient par le nombre
// de points. Couleur, emoji, bordure et ombre sont conserves.
function marqueurDecore(coords, color, emoji, opts) {
  opts = opts || {};
  var taille = opts.taille || 38;
  var police = opts.police || 19;
  var sobre = !!opts.sobre;
  var pulse = opts.pulse !== false && !sobre;
  return L.marker(coords, { icon: L.divIcon({
    html: '<div class="mk' + (sobre ? ' mk-sobre' : '') + '" style="background:' + color + ';color:' + color +
          (taille !== 38 ? ';width:' + taille + 'px;height:' + taille + 'px' : '') + '">' +
          (pulse ? '<span class="mk-pulse"></span>' : '') +
          '<span class="mk-emoji"' + (police !== 19 ? ' style="font-size:' + police + 'px"' : '') + '>' + emoji + '</span></div>',
    iconSize: [taille, taille],
    iconAnchor: [taille / 2, taille / 2],
    className: ''
  }) });
}

function clearMarkers() {
  markers.forEach(function(m){ try { map.removeLayer(m); } catch(e){} });
  markers = [];
  if (markerGroup) { try { map.removeLayer(markerGroup); } catch(e){} markerGroup = null; }
  clearCircles();
  clearPolylines();
}

function updateMarkers(jsonData) {
  clearMarkers();
  var data;
  try { data = JSON.parse(jsonData); } catch(e) { return; }
  if (!data || data.length === 0) {
    document.getElementById('empty').style.display = 'block';
    return;
  }
  document.getElementById('empty').style.display = 'none';
  var bounds = [];
  // Beaucoup de points : on regroupe. Si le CDN du cluster n'a pas repondu, on
  // retombe sur des pastilles canvas (sans animation ni blur) -- moins jolies,
  // mais la carte reste utilisable. Ne jamais laisser 548 marqueurs decores.
  var nombreux = data.length > SEUIL_REGROUPEMENT;
  markerGroup = creerGroupe(data.length);
  var regroupe = !!markerGroup;
  var pastilles = nombreux && !regroupe;
  data.forEach(function(ad) {
    var color = catColors[ad.cat] || '#C8001A';
    var emoji = catEmojis[ad.cat] || '⭐';
    var marker;
    if (pastilles) {
      marker = L.circleMarker(ad.coords, { radius: 7, color: '#fff', weight: 2, fillColor: color, fillOpacity: 1 });
    } else {
      // Meme regroupes, plusieurs centaines de marqueurs peuvent redevenir
      // visibles en zoomant : on passe donc en mode sobre des qu'il y a foule.
      marker = marqueurDecore(ad.coords, color, emoji, { sobre: nombreux });
    }
    if (regroupe) { markerGroup.addLayer(marker); } else { marker.addTo(map); }
    var photoStyle = ad.photo ? 'background-image:url(' + safeUrl(ad.photo) + ')' : '';
    var popupHtml = '<div class="popup-card" data-ad-id="' + ad.id + '">' + 
      (ad.photo ? '<div class="popup-photo" style="' + photoStyle + '"></div>' : '') +
      '<div class="popup-info">' +
      '<div class="popup-title">' + esc(ad.title) + '</div>' +
      '<div class="popup-loc">📍 ' + esc(ad.loc) + '</div>' +
      (ad.price ? '<div class="popup-price">' + esc(ad.price) + '</div>' : '') +
      '</div></div>';
    marker.bindPopup(popupHtml);
    marker.on('popupopen', function() {
      // Rayon d'intervention (pros mobiles) : cercle affiché au clic, retiré à la fermeture.
      clearCircles();
      if (ad.radiusKm && ad.radiusKm > 0) {
        var circle = L.circle(ad.coords, { radius: ad.radiusKm * 1000, color: color, weight: 2, opacity: 0.7, fillColor: color, fillOpacity: 0.08 }).addTo(map);
        circles.push(circle);
        try { map.fitBounds(circle.getBounds(), { padding: [40, 40], maxZoom: 12 }); } catch(e) {}
      }
      setTimeout(function() {
        var card = document.querySelector('.popup-card[data-ad-id="' + ad.id + '"]');
        if (card) {
          card.onclick = function() {
            window.parent.postMessage({ type: 'horseconnex_ad_click', adId: ad.id }, '*');
          };
        }
      }, 50);
    });
    marker.on('popupclose', function() { clearCircles(); });
    marker._hcId = ad.id;
    markers.push(marker);
    bounds.push(ad.coords);
  });
  if (regroupe) { map.addLayer(markerGroup); }
  // __markersFit : recadrage auto sur l'ensemble des marqueurs. On le coupe quand
  // l'appelant veut imposer sa propre vue (bouton "Voir sur la carte" d'une fiche) —
  // sinon ce fitBounds anime le zoom et Leaflet ignore le setView qui suit.
  if (bounds.length > 0 && __markersFit) {
    if (bounds.length === 1) {
      map.setView(bounds[0], 10);
    } else {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
    }
  }
}
var __markersFit = true;
window.setMarkersAutoFit = function(v){ __markersFit = !!v; };

// Ouvre la bulle d'un marqueur precis (arrivee depuis "Voir sur la carte" d'une
// fiche) : on veut voir la fiche presentee, pas un point parmi d'autres.
// L'ouverture declenche popupopen, donc aussi le cercle de rayon s'il y en a un.
// ⚠️ Un marqueur range dans un cluster REPLIE n'est pas sur la carte : son
// openPopup() ne fait rien du tout, sans la moindre erreur. Il faut demander au
// cluster de s'ouvrir d'abord (zoomToShowLayer), sinon le bouton "Voir sur la
// carte" resterait muet des que l'annuaire depasse le seuil de regroupement.
window.openMarkerPopup = function(id){
  for (var i = 0; i < markers.length; i++) {
    if (markers[i]._hcId !== id) continue;
    var m = markers[i];
    if (markerGroup && typeof markerGroup.zoomToShowLayer === 'function') {
      try {
        markerGroup.zoomToShowLayer(m, function(){ try { m.openPopup(); } catch(e) {} });
        return true;
      } catch(e) { /* on retombe sur l'ouverture directe */ }
    }
    try { m.openPopup(); } catch(e) {}
    return true;
  }
  return false;
};

// HorseRoad : trace les itinéraires (ligne directe départ -> arrivée).
// Chaque item : {id, type, color, from:[lat,lng], to:[lat,lng], title, dep, arr, date, price}
function updateRoutes(jsonData) {
  clearMarkers();
  var data;
  try { data = JSON.parse(jsonData); } catch(e) { return; }
  if (!data || data.length === 0) { document.getElementById('empty').style.display = 'block'; return; }
  document.getElementById('empty').style.display = 'none';
  var bounds = [];
  // Chaque trajet pose DEUX marqueurs (depart + arrivee), dont un anime : le
  // cout grimpe deux fois plus vite que le nombre de trajets. Meme traitement
  // que l'annuaire, pose des maintenant pour ne pas le redecouvrir plus tard.
  var nombreuxTrajets = data.length * 2 > SEUIL_REGROUPEMENT;
  markerGroup = creerGroupe(data.length * 2);
  data.forEach(function(tr) {
    if (!tr.from || !tr.to) return;
    var color = tr.color || '#C8001A';
    var line = L.polyline([tr.from, tr.to], { color: color, weight: 4, opacity: 0.9, dashArray: tr.type === 'request' ? '7 9' : undefined, lineCap: 'round' }).addTo(map);
    polylines.push(line);
    var m1 = marqueurDecore(tr.from, color, '📍', { taille: 26, police: 13, pulse: false, sobre: nombreuxTrajets });
    var m2 = marqueurDecore(tr.to, color, '🏁', { taille: 30, police: 15, sobre: nombreuxTrajets });
    if (markerGroup) { markerGroup.addLayer(m1); markerGroup.addLayer(m2); }
    else { m1.addTo(map); m2.addTo(map); }
    markers.push(m1); markers.push(m2);
    var popupHtml = '<div class="popup-card" data-trip-id="' + tr.id + '"><div class="popup-info">' +
      '<div class="popup-title">' + esc(tr.title) + '</div>' +
      '<div class="popup-loc">' + esc(tr.dep) + ' → ' + esc(tr.arr) + '</div>' +
      (tr.date ? '<div class="popup-loc">📅 ' + esc(tr.date) + '</div>' : '') +
      (tr.price ? '<div class="popup-price">' + esc(tr.price) + '</div>' : '') +
      '</div></div>';
    line.bindPopup(popupHtml); m1.bindPopup(popupHtml); m2.bindPopup(popupHtml);
    function wire() { setTimeout(function() { var c = document.querySelector('.popup-card[data-trip-id="' + tr.id + '"]'); if (c) { c.onclick = function() { window.parent.postMessage({ type: 'horseconnex_trip_click', tripId: tr.id }, '*'); }; } }, 50); }
    line.on('popupopen', wire); m1.on('popupopen', wire); m2.on('popupopen', wire);
    bounds.push(tr.from); bounds.push(tr.to);
  });
  if (markerGroup) { map.addLayer(markerGroup); }
  if (bounds.length > 0) { try { map.fitBounds(bounds, { padding: [55,55], maxZoom: 11 }); } catch(e) {} }
}

// === RANDONNÉES : itinéraires (polylines multi-points) + points utiles (POI) ===
// Chargement par zone visible (viewport) : la carte émet ses limites, React
// interroge les itinéraires dans cette zone. __trailsFit désactive le recadrage
// auto (sinon boucle moveend->reload->fitBounds). Vue d'ensemble = false ; fiche = true.
var __trailsFit = true;
window.setTrailsAutoFit = function(v){ __trailsFit = !!v; };
function emitTrailBounds(){ try { var b=map.getBounds(); window.parent.postMessage({ type:'horseconnex_map_bounds', s:b.getSouth(), w:b.getWest(), n:b.getNorth(), e:b.getEast(), zoom:map.getZoom() }, '*'); } catch(e){} }
map.on('moveend', emitTrailBounds);
var trailLines = [];
var poiMarkers = [];
function clearTrails(){ trailLines.forEach(function(l){try{map.removeLayer(l);}catch(e){}}); trailLines=[]; }
var poiGroup = null;
function clearPois(){
  poiMarkers.forEach(function(m){try{map.removeLayer(m);}catch(e){}}); poiMarkers=[];
  if (poiGroup) { try { map.removeLayer(poiGroup); } catch(e){} poiGroup = null; }
}
var diffColors = { facile:'#047857', moyen:'#C4690A', difficile:'#B42020' };
var poiMeta = { gite_etape:{c:'#7C3AED',e:'🏠'}, eau:{c:'#0891B2',e:'💧'}, parking_van:{c:'#1A1A2E',e:'🚚'}, ferme_accueil:{c:'#5A9020',e:'🚜'}, danger:{c:'#B42020',e:'⚠️'}, point_vue:{c:'#C4690A',e:'👁️'}, gue:{c:'#0369A1',e:'🌊'}, abri:{c:'#7C2D12',e:'⛺'} };
function drawPois(pois){
  clearPois();
  var liste = (pois||[]).filter(function(p){ return p.lat!=null && p.lng!=null; });
  // Les gites d'etape de l'annuaire remontent ici : le nombre de points utiles
  // suit donc la croissance de l'annuaire, pas seulement celle des randonnees.
  var nombreuxPois = liste.length > SEUIL_REGROUPEMENT;
  poiGroup = creerGroupe(liste.length);
  liste.forEach(function(p){
    var m = poiMeta[p.type]||{c:'#1A1A2E',e:'📍'};
    var mk = marqueurDecore([p.lat,p.lng], m.c, m.e, { taille:30, police:15, pulse:false, sobre:nombreuxPois });
    if (poiGroup) { poiGroup.addLayer(mk); } else { mk.addTo(map); }
    var popupHtml = '<div class="popup-card" data-poi-id="'+p.id+'"><div class="popup-info"><div class="popup-title">'+m.e+' '+esc(p.title)+'</div>'+(p.description?'<div class="popup-loc">'+esc(p.description)+'</div>':'')+'</div></div>';
    mk.bindPopup(popupHtml);
    mk.on('popupopen', function(){ setTimeout(function(){ var c=document.querySelector('.popup-card[data-poi-id="'+p.id+'"]'); if(c){ c.onclick=function(){ window.parent.postMessage({type:'horseconnex_poi_click',poiId:p.id},'*'); }; } },50); });
    poiMarkers.push(mk);
  });
  if (poiGroup) { map.addLayer(poiGroup); }
}
function updateTrails(jsonData){
  clearMarkers(); clearTrails();
  var data; try { data = JSON.parse(jsonData); } catch(e){ return; }
  var bounds = [];
  (data.trails||[]).forEach(function(tr){
    var pts = tr.path||[];
    var color = diffColors[tr.difficulty]||'#C8001A';
    if (pts.length>=2){
      var line = L.polyline(pts, {color:color, weight:5, opacity:.85, lineCap:'round', lineJoin:'round'}).addTo(map);
      trailLines.push(line);
      pts.forEach(function(p){ bounds.push(p); });
    }
    var start = (tr.start_lat!=null&&tr.start_lng!=null)?[tr.start_lat,tr.start_lng]:(pts[0]||null);
    if (start && !tr.nomarker){
      // Point léger (canvas) au lieu d'un marqueur DOM animé : indispensable
      // quand des centaines d'itinéraires sont visibles (dézoom fluide).
      var mk = L.circleMarker(start, { radius:6, color:'#fff', weight:2, fillColor:color, fillOpacity:1 }).addTo(map);
      var popupHtml = '<div class="popup-card" data-trail-id="'+tr.id+'">'+(tr.photo?'<div class="popup-photo" style="background-image:url('+safeUrl(tr.photo)+')"></div>':'')+'<div class="popup-info"><div class="popup-title">'+esc(tr.title)+'</div><div class="popup-loc">'+esc(tr.meta)+'</div></div></div>';
      mk.bindPopup(popupHtml);
      mk.on('popupopen', function(){ setTimeout(function(){ var c=document.querySelector('.popup-card[data-trail-id="'+tr.id+'"]'); if(c){ c.onclick=function(){ window.parent.postMessage({type:'horseconnex_trail_click',trailId:tr.id},'*'); }; } },50); });
      markers.push(mk); bounds.push(start);
    }
  });
  drawPois(data.pois||[]);
  var emp=document.getElementById('empty'); if(emp) emp.style.display=((bounds.length===0)&&((data.pois||[]).length===0))?'block':'none';
  if (__trailsFit && bounds.length>0){ try { map.fitBounds(bounds,{padding:[50,50],maxZoom:13}); } catch(e){} }
}
function updatePois(jsonData){ var d; try{ d=JSON.parse(jsonData); }catch(e){ return; } drawPois(d||[]); }

// === MODE DESSIN (créer un tracé sans GPS : chaque clic = un point) ===
var drawPts = [];
var drawLine = null;
var drawDots = [];
var drawing = false;
function redrawDraw(){
  if (drawLine){ try{map.removeLayer(drawLine);}catch(e){} drawLine=null; }
  drawDots.forEach(function(d){try{map.removeLayer(d);}catch(e){}}); drawDots=[];
  if (drawPts.length>=2){ drawLine=L.polyline(drawPts,{color:'#C8001A',weight:5,opacity:.9,lineCap:'round'}).addTo(map); }
  drawPts.forEach(function(p){ var d=L.circleMarker(p,{radius:5,color:'#fff',weight:2,fillColor:'#C8001A',fillOpacity:1}).addTo(map); drawDots.push(d); });
}
function emitDraw(){ try { window.parent.postMessage({type:'horseconnex_draw_update', points:drawPts}, '*'); } catch(e){} }
var addMode = 'path'; // 'path' (tracé) | 'poi' (point utile)
map.on('click', function(e){
  if(!drawing) return;
  if(addMode === 'poi'){ try{ window.parent.postMessage({type:'horseconnex_map_click', lat:e.latlng.lat, lng:e.latlng.lng}, '*'); }catch(err){} return; }
  drawPts.push([e.latlng.lat, e.latlng.lng]); redrawDraw(); emitDraw();
});
window.setDrawMode = function(on){ drawing = !!on; };
window.setAddMode = function(m){ addMode = (m === 'poi') ? 'poi' : 'path'; };
window.undoDrawPoint = function(){ drawPts.pop(); redrawDraw(); emitDraw(); };
window.clearDraw = function(){ drawPts=[]; redrawDraw(); emitDraw(); };
window.setDrawPath = function(pts){ drawPts = pts||[]; redrawDraw(); emitDraw(); if(drawPts.length>0){ try{map.fitBounds(drawPts,{padding:[40,40],maxZoom:14});}catch(e){} } };
window.getMapCenter = function(){ var c=map.getCenter(); return [c.lat, c.lng]; };
window.setMapView = function(lat, lng, zoom){ try { map.setView([lat, lng], zoom || 11); } catch(e){} };

function filterMap(cat) { /* géré par React via updateMarkers */ }

window.goToLocation = function(lat, lng, zoom) {
  if (window.userMarker) { map.removeLayer(window.userMarker); }
  window.userMarker = L.marker([lat, lng], {
    icon: L.divIcon({
      className: 'user-loc-marker',
      html: '<div style="position:relative;width:22px;height:22px;"><div style="position:absolute;inset:-6px;border-radius:50%;background:rgba(59,130,246,.3);animation:mk-ping 2s ease-out infinite;"></div><div style="position:relative;width:22px;height:22px;border-radius:50%;background:#3B82F6;border:3px solid #fff;box-shadow:0 4px 14px rgba(59,130,246,.45);"></div></div>',
      iconSize: [28, 28],
      iconAnchor: [14, 14]
    })
  }).addTo(map);
  window.userMarker.bindPopup('<b style="color:#fff">Vous êtes ici</b>').openPopup();
  map.setView([lat, lng], zoom || 13);
};

// === SUIVI EN DIRECT (position du cavalier sur un tracé) ===
// Le parent envoie chaque relevé GPS ; ici on ne fait qu'afficher :
// point bleu + cercle de précision + trait pointillé vers le tracé si hors
// piste. Recentrage automatique, mis en pause 15 s quand l'utilisateur
// déplace la carte lui-même (sinon impossible de regarder plus loin).
var liveMarker = null, liveCircle = null, liveLink = null, livePauseUntil = 0;
map.on('dragstart', function(){ livePauseUntil = Date.now() + 15000; });
window.setLive = function(json){
  var d; try { d = JSON.parse(json); } catch(e){ return; }
  if (d == null || d.lat == null || d.lng == null) return;
  var ll = [d.lat, d.lng];
  if (!liveMarker) {
    liveMarker = L.marker(ll, { zIndexOffset: 1000, interactive: false, icon: L.divIcon({
      className: 'user-loc-marker',
      html: '<div style="position:relative;width:22px;height:22px;"><div style="position:absolute;inset:-6px;border-radius:50%;background:rgba(59,130,246,.3);animation:mk-ping 2s ease-out infinite;"></div><div style="position:relative;width:22px;height:22px;border-radius:50%;background:#3B82F6;border:3px solid #fff;box-shadow:0 4px 14px rgba(59,130,246,.45);"></div></div>',
      iconSize: [28, 28], iconAnchor: [14, 14] }) }).addTo(map);
    liveCircle = L.circle(ll, { radius: d.acc || 0, color: '#3B82F6', weight: 1, opacity: .5, fillColor: '#3B82F6', fillOpacity: .12, interactive: false }).addTo(map);
  } else {
    liveMarker.setLatLng(ll);
    liveCircle.setLatLng(ll); liveCircle.setRadius(d.acc || 0);
  }
  if (liveLink) { try { map.removeLayer(liveLink); } catch(e){} liveLink = null; }
  if (d.off && d.proj && d.proj.length === 2) {
    liveLink = L.polyline([ll, d.proj], { color: '#B42020', weight: 3, dashArray: '6 8', opacity: .9, interactive: false }).addTo(map);
  }
  if (d.follow && Date.now() > livePauseUntil) {
    try { map.setView(ll, Math.max(map.getZoom(), 15), { animate: false }); } catch(e){}
  }
};
window.clearLive = function(){
  [liveMarker, liveCircle, liveLink].forEach(function(l){ if (l) { try { map.removeLayer(l); } catch(e){} } });
  liveMarker = null; liveCircle = null; liveLink = null;
};
// Ligne d'une balade EN COURS d'enregistrement : une seule polyligne mise à
// jour (setLatLngs), sans pastille par point ni fitBounds — à 1 point/s le
// mode dessin (setDrawPath) coûterait un marqueur DOM par relevé.
var recLine = null;
window.setRecLine = function(json){
  var pts; try { pts = JSON.parse(json); } catch(e){ return; }
  if (!Array.isArray(pts)) return;
  if (!recLine) { recLine = L.polyline(pts, { color: '#C8001A', weight: 5, opacity: .9, lineCap: 'round', lineJoin: 'round', interactive: false }).addTo(map); }
  else { recLine.setLatLngs(pts); }
};
window.clearRecLine = function(){ if (recLine) { try { map.removeLayer(recLine); } catch(e){} recLine = null; } };

// Signaler que la carte est prete
setTimeout(function() {
  window.parent.postMessage({ type: 'horseconnex_map_ready' }, '*');
  emitTrailBounds();
}, 500);
<\/script><\/body><\/html>`;

export const COUNTRY_NEIGHBORS = {
  CH: ["FR", "DE", "IT", "AT", "LU", "MC", "BE", "NL"],
  FR: ["CH", "BE", "DE", "IT", "ES", "LU", "MC", "GB", "IE", "PT", "NL", "AT"],
  BE: ["FR", "DE", "NL", "LU", "GB", "CH"],
  NL: ["BE", "DE", "FR", "GB", "LU", "DK"],
  DE: ["FR", "BE", "NL", "CH", "AT", "PL", "DK", "LU"],
  GB: ["IE", "FR", "BE", "NL", "NO"],
  IE: ["GB", "FR"],
  IT: ["FR", "CH", "AT", "MC", "ES"],
  ES: ["FR", "PT", "MC"],
  PT: ["ES", "FR"],
  AT: ["DE", "CH", "IT", "PL"],
  SE: ["NO", "DK", "DE", "PL"],
  NO: ["SE", "DK", "GB"],
  DK: ["DE", "SE", "NO", "NL"],
  PL: ["DE", "AT"],
  LU: ["FR", "BE", "DE", "CH"],
  MC: ["FR", "IT"],
  US: ["CA", "MX"],
  CA: ["US"],
  AR: ["BR", "MX"],
  BR: ["AR", "MX"],
  MX: ["US", "BR", "AR"],
  AE: [],
  AU: ["NZ"],
  NZ: ["AU"],
  OTHER: []
};

export const REGION_COORDS = {
  "Vaud": [46.5197, 6.6323], "Geneve": [46.2044, 6.1432], "Fribourg": [46.8065, 7.1614],
  "Valais": [46.2270, 7.3610], "Neuchatel": [46.9897, 6.9293], "Jura": [47.3667, 7.0167],
  "Berne": [46.9480, 7.4474], "Tessin": [46.1670, 8.7943], "Zurich": [47.3769, 8.5417],
  "Lucerne": [47.0502, 8.3093], "Argovie": [47.3877, 8.2554], "Soleure": [47.2088, 7.5323],
  "Saint-Gall": [47.4245, 9.3767], "Grisons": [46.6562, 9.5780], "Schwyz": [47.0207, 8.6530],
  "Thurgovie": [47.5603, 9.0557], "Schaffhouse": [47.6979, 8.6347], "Appenzell": [47.3315, 9.4099],
  "Uri": [46.7726, 8.6014], "Glaris": [47.0399, 9.0667], "Obwald": [46.8779, 8.2511],
  "Nidwald": [46.9265, 8.3850], "Zoug": [47.1662, 8.5155],
  "Ile-de-France": [48.8566, 2.3522], "Auvergne-Rhone-Alpes": [45.7640, 4.8357],
  "Normandie": [49.4938, 0.1077], "Occitanie": [43.6047, 3.8769],
  "Nouvelle-Aquitaine": [44.8378, -0.5792], "Hauts-de-France": [50.6292, 3.0573],
  "Grand Est": [48.5734, 7.7521], "Bretagne": [48.2020, -2.9326],
  "Pays de la Loire": [47.2184, -1.5536], "Bourgogne-Franche-Comte": [47.2819, 4.0801],
  "Centre-Val de Loire": [47.7516, 1.6751], "Corse": [42.0396, 9.0129],
  "Wallonie": [50.4669, 4.8675], "Flandre": [51.0500, 3.7333], "Bruxelles": [50.8503, 4.3517],
  "Baviere": [48.7904, 11.4979], "Bade-Wurtemberg": [48.6616, 9.3501],
  "Hesse": [50.6520, 9.1624], "Berlin": [52.5200, 13.4050], "Hambourg": [53.5511, 9.9937],
  "Angleterre": [52.3555, -1.1743], "Ecosse": [56.4907, -4.2026],
  "Pays de Galles": [52.1307, -3.7837], "Irlande du Nord": [54.7877, -6.4923],
  "Dublin": [53.3498, -6.2603],
  "Lombardie": [45.4642, 9.1900], "Toscane": [43.7711, 11.2486],
  "Venetie": [45.4408, 12.3155], "Latium": [41.9028, 12.4964],
  "Catalogne": [41.3851, 2.1734], "Andalousie": [37.3886, -5.9823],
  "Madrid": [40.4168, -3.7038], "Valence": [39.4699, -0.3763],
  "Lisbonne": [38.7223, -9.1393], "Porto": [41.1579, -8.6291],
  "Vienne": [48.2082, 16.3738], "Tyrol": [47.2692, 11.4041],
  "Stockholm": [59.3293, 18.0686], "Oslo": [59.9139, 10.7522],
  "Copenhague": [55.6761, 12.5683], "Luxembourg": [49.6116, 6.1319],
  "Monaco": [43.7384, 7.4246], "Mazovie": [52.2297, 21.0122],
  "Californie": [36.7783, -119.4179], "Texas": [31.9686, -99.9018],
  "Floride": [27.6648, -81.5158], "Kentucky": [37.8393, -84.2700],
  "New York": [40.7128, -74.0060],
  "Ontario": [51.2538, -85.3232], "Quebec": [46.8139, -71.2080],
  "Buenos Aires": [-34.6037, -58.3816],
  "Sao Paulo": [-23.5505, -46.6333], "Rio de Janeiro": [-22.9068, -43.1729],
  "Mexico": [19.4326, -99.1332],
  "Dubai": [25.2048, 55.2708], "Abu Dhabi": [24.4539, 54.3773],
  "Auckland": [-36.8485, 174.7633], "Wellington": [-41.2865, 174.7762]
};

export const COUNTRY_COORDS = {
  CH: [46.8182, 8.2275], FR: [46.2276, 2.2137], BE: [50.5039, 4.4699],
  NL: [52.1326, 5.2913], DE: [51.1657, 10.4515], GB: [55.3781, -3.4360],
  IE: [53.4129, -8.2439], IT: [41.8719, 12.5674], ES: [40.4637, -3.7492],
  PT: [39.3999, -8.2245], AT: [47.5162, 14.5501], SE: [60.1282, 18.6435],
  NO: [60.4720, 8.4689], DK: [56.2639, 9.5018], PL: [51.9194, 19.1451],
  LU: [49.8153, 6.1296], MC: [43.7384, 7.4246],
  US: [37.0902, -95.7129], CA: [56.1304, -106.3468], AR: [-38.4161, -63.6167],
  BR: [-14.2350, -51.9253], MX: [23.6345, -102.5528],
  AE: [23.4241, 53.8478], AU: [-25.2744, 133.7751], NZ: [-40.9006, 174.8860],
  OTHER: [0, 0]
};
